import { useDetailApi } from "../../../swr";
import { partnersService } from "../../api_client";
import type { PartnerStatsDto } from "../../../api";

export function usePartnerStatsById(partnerId: number) {
  return useDetailApi<PartnerStatsDto>({
    key: `/partners/${partnerId}/stats`,
    serviceMethod: () => partnersService.getPartnerStats(partnerId),
  });
}
